'use client';

import { __makeTemplateObject } from '../../_virtual/_tslib.js';
import styled from 'styled-components';

var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var GuideText = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: 14px;\n    line-height: 21px;\n    margin-bottom: 10px;\n"], ["\n    font-size: 14px;\n    line-height: 21px;\n    margin-bottom: 10px;\n"])));
var GuideImage = styled.img(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    width: 100%;\n"], ["\n    width: 100%;\n"])));
var templateObject_1, templateObject_2, templateObject_3;

export { Container, GuideImage, GuideText };
//# sourceMappingURL=styles.js.map
